import styled from 'styled-components';
import ImgFooter from '../../../../assets/svg/footer.svg';

const ContainerFooter = styled.div`
  background-image: url(${ImgFooter});
  width: 100%;
  height: 400px;
  background-repeat: no-repeat;
  background-size: contain;
  background-size: cover;
  background-position: center;
`;
export { ContainerFooter };
